export enum SortOrderStrategy {
  ALPHABETICAL = 'alphabetical',
  LAST_ACTIVITY = 'lastActivity',
}
